module.exports = "<p>\n  built-drawing works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/built-drawing/built-drawing.component.html
// module id = ./src/app/planning/built-drawing/built-drawing.component.html
// module chunks = main